import { render, staticRenderFns } from "./ExamTheoryPaper.vue?vue&type=template&id=420a24a4&scoped=true&"
import script from "./ExamTheoryPaper.vue?vue&type=script&lang=js&"
export * from "./ExamTheoryPaper.vue?vue&type=script&lang=js&"
import style0 from "./ExamTheoryPaper.vue?vue&type=style&index=0&id=420a24a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a24a4",
  null
  
)

export default component.exports